var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { format } from "date-fns";
import { computed } from "mobx";
import { NOT_LOADED } from "../Infra/RemoteData";
import { getObservableT, i18nGetDateFnsLocale } from "../Infra/i18next";
import { PatientConsentViewModel } from "./PatientConsentViewModel";
import { getTranslatedStudyText } from "./TranslationService";
const t = getObservableT("patients");
export const hipaaContentLoadedClassName = "hipaaContentLoaded";
export class PatientConsentHipaaAuthorizationViewModel extends PatientConsentViewModel {
    constructor(container) {
        super(container);
        this.authManager = container.authManager;
    }
    getTranslatedText(key) {
        if (this.study === NOT_LOADED || this.study === null)
            return "";
        return getTranslatedStudyText(this.study, key, this.patientConsentUIManager.currentLanguage) || "";
    }
    get expiryDate() {
        var _a;
        const dateFormat = "LLL dd, yyyy";
        const locale = i18nGetDateFnsLocale();
        if ((_a = this.consentFlowPageData) === null || _a === void 0 ? void 0 : _a.expirationTimestamp) {
            return format(new Date(this.consentFlowPageData.expirationTimestamp), dateFormat, { locale });
        }
        if (!this.patientConsentUIManager.consentExpirationDate)
            return null;
        return format(new Date(this.patientConsentUIManager.consentExpirationDate), dateFormat, { locale });
    }
    get hipaaAuthorizationContent() {
        if (this.prescreenOrEnrollmentStudy === NOT_LOADED || this.prescreenOrEnrollmentStudy === null) {
            return null;
        }
        if (this.prescreenOrEnrollmentStudy.pdda) {
            const legalName = this.getCustomizedText("hipaaOrganizationLegalName");
            return { type: "pdda", legalName };
        }
        else if (this.prescreenOrEnrollmentStudy.hipaaAuthorizationTemplateEnabled) {
            const url = this.prescreenOrEnrollmentStudy.hipaaAuthorizationFormUrl;
            return url ? { type: "url", url } : null;
        }
        else {
            const text = this.getTranslatedText("hipaaAuthorizationText");
            return text ? { type: "text", text } : null;
        }
    }
    get hipaaContentLoadedClassName() {
        return this.isScreenshotMode ? hipaaContentLoadedClassName : undefined;
    }
    get fullscreenButtonEnabled() {
        return !this.patientConsentUIManager.session.isSubmittingConsent;
    }
    get confirmButtonEnabled() {
        return !this.patientConsentUIManager.session.isSubmittingConsent;
    }
    get declineButtonEnabled() {
        return !this.patientConsentUIManager.session.isSubmittingConsent;
    }
    async agree() {
        this.goToNextPage();
    }
    async doNotAgree() {
        await this.patientConsentUIManager.declineConsent();
    }
    showHipaaAuthorizationFormDialog() {
        this.hipaaAuthorizationFormDialogOpen = true;
    }
    hideHipaaAuthorizationFormDialog() {
        this.hipaaAuthorizationFormDialogOpen = false;
    }
}
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "expiryDate", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "hipaaAuthorizationContent", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "hipaaContentLoadedClassName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "fullscreenButtonEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "confirmButtonEnabled", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], PatientConsentHipaaAuthorizationViewModel.prototype, "declineButtonEnabled", null);
